<template>
    <div class="text-center login-box">
        <form class="form-signin">
            <h1 class="h3 mb-3 font-weight-normal">Please Sign In</h1>

            <div class="form-group">
                <label class="sr-only" for="nickname">nickname</label>
                <p :class="{ control: true }">
                    <input
                        v-validate="'required'"
                        v-model.lazy="user.nickname"
                        class="form-control"
                        :class="{
                            input: true,
                            'is-danger': errors.has('nickname'),
                        }"
                        name="nickname"
                        placeholder="demo"
                    />
                    <span
                        v-show="errors.has('nickname')"
                        class="help text-danger"
                        >{{ errors.first("nickname") }}</span
                    >
                </p>
            </div>

            <div class="form-group">
                <label for="password" class="sr-only">Password</label>
                <p :class="{ control: true }">
                    <input
                        type="password"
                        id="password"
                        v-model.lazy="user.password"
                        v-validate="'required'"
                        class="form-control"
                        :class="{
                            input: true,
                            'is-danger': errors.has('password'),
                        }"
                        name="password"
                        placeholder="password"
                    />
                    <span
                        v-show="errors.has('password')"
                        class="help text-danger"
                        >{{ errors.first("password") }}</span
                    >
                </p>
            </div>

            <button
                class="btn btn-lg btn-primary btn-block"
                type="submit"
                @click.prevent="login"
            >
                Sign in
            </button>
            <p class="mt-5 mb-3 text-muted">&copy; 2017-2018</p>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: {
                nickname: "",
                password: "",
            },
        };
    },
    methods: {
        login() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$http
                        .post(`${API_URL}/auth/user`, this.user)
                        .then(({ data }) => {
                            if (data.auth) {
                                this.$store.dispatch("setUser", data.auth);
                                if (data.auth.form == 2) {
                                    this.$router.push("/dues");
                                } else {
                                    this.$router.push("/");
                                }
                            } else {
                                this.onLoginError({
                                    message: "credenciales invalidas",
                                });
                            }
                        })
                        .catch((err) => {
                            if (err.response) {
                                this.onLoginError(err.response.data);
                            } else {
                                console.log(err);
                            }
                        });
                    return;
                }

                this.$toastr.warning("the form has some errors");
            });
        },

        onLoginError(error) {
            this.$notify({
                title: "Error",
                message: error.message,
                type: "error",
            });
        },
    },
};
</script>

<style lang="sass" scoped>
.login-box
	padding-top: 70px
	height: 60vh
	width: 100%
	display: flex
	align-items: center
	justify-content: center

	form
		width: 50%
</style>
